import { CommonModule } from '@angular/common';
import { Component, OnInit, computed } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PermisosService } from '../../services/permisos.service';
import { PageHeaderComponent } from '../ui/page-header.component';
import { EstadoPanelComponent } from '../ui/estado-panel.component';

export interface ServiceCenso {
  id: string;
  titulo: string;
  url: string;
  /** Permisos que dan acceso (basta uno). Es solo UX: la API autoriza cada acción. */
  permisos: string[];
  soloGlobal?: boolean;
  /** Presentación (Wave 7): icono, texto explicativo y sección de color. No cambia el acceso. */
  icono?: string;
  descripcion?: string;
  seccion?: string;
  grupo?: 'censo' | 'administracion';
}

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterModule, PageHeaderComponent, EstadoPanelComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  private readonly consulta = ['asociados:consultar', 'asociaciones:consultar', 'asociaciones:escribir', 'historico:consultar'];

  servicios: ServiceCenso[] = [
    { id: '0', titulo: 'Asociaciones', url: '/asociaciones', permisos: this.consulta, icono: 'bi-people-fill', seccion: 'asociaciones', grupo: 'censo', descripcion: 'Foguera y barracas: datos, contacto, acceso y asociados vinculados.' },
    { id: '1', titulo: 'Asociados', url: '/asociados', permisos: ['asociados:consultar'], soloGlobal: true, icono: 'bi-person-fill', seccion: 'asociados', grupo: 'censo', descripcion: 'Busca personas por nombre, DNI/NIF, teléfono o correo y consulta su ficha.' },
    { id: '2', titulo: 'Ejercicios', url: '/ejercicios', permisos: ['asociados:consultar', 'ejercicios:gestionar'], soloGlobal: true, icono: 'bi-calendar-fill', seccion: 'ejercicios', grupo: 'censo', descripcion: 'Ejercicio vigente y anteriores, con sus asociaciones y asociados.' },
    { id: '3', titulo: 'Cargos', url: '/cargos', permisos: ['asociados:consultar', 'cargos:gestionar'], soloGlobal: true, icono: 'bi-award-fill', seccion: 'cargos', grupo: 'censo', descripcion: 'Catálogo de cargos y quiénes los ostentan.' },
    { id: '4', titulo: 'Histórico', url: '/historico', permisos: ['asociados:consultar'], soloGlobal: true, icono: 'bi-archive-fill', seccion: 'historico', grupo: 'censo', descripcion: 'Relaciones entre personas, asociaciones y cargos por ejercicio.' },
    { id: '6', titulo: 'Permisos', url: '/permisos', permisos: ['permisos:gestionar'], soloGlobal: true, icono: 'bi-shield-lock-fill', seccion: 'admin', grupo: 'administracion', descripcion: 'Qué puede hacer cada cargo en Censo.' },
    { id: '7', titulo: 'Administración de asociaciones', url: '/administracion/asociaciones', permisos: ['asociaciones:estado'], soloGlobal: true, icono: 'bi-toggles', seccion: 'admin', grupo: 'administracion', descripcion: 'Activar o desactivar el acceso de varias asociaciones a la vez.' }
  ];

  readonly visibles = computed(() => {
    this.permisos.contexto();
    return this.servicios.filter(servicio => servicio.soloGlobal
      ? servicio.permisos.some(permiso => this.permisos.tieneGlobal(permiso))
      : this.permisos.tieneAlguno(servicio.permisos));
  });

  readonly visiblesCenso = computed(() => this.visibles().filter(s => s.grupo !== 'administracion'));
  readonly visiblesAdmin = computed(() => this.visibles().filter(s => s.grupo === 'administracion'));

  constructor(readonly permisos: PermisosService) {}

  ngOnInit(): void {
    this.permisos.cargarContexto().subscribe();
  }
}
